import React from "react";
import { URL } from "screen/00_Nav/url";
import { Layout, Row, Col } from "antd";
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import SectionCointaner from "component/sections/section_container";
import TriggerInit from "./trigger/trigger_init";
import KycHeader from "./component/kyc_header";
import KycFilter from "./component/kyc_filter";
import KycTable from "./component/kyc_table";
import DialogKycAction from "./dialog/dialog_kyc_action";

//
//component
//redux
//selector
//actions
//utils
//hook

//str

const breadCrum = [
  {
    title: "Home",
    url: null,
  },
  {
    title: "KYC",
    url: URL.kyc,
  },
];

const KycApprove = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 20]}>
        <Col xl={18} lg={18} md={18} xs={24}>
          <KycHeader />
        </Col>
        <Col align="right" xl={6} lg={6} md={6} xs={24}>
          <KycFilter />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <KycTable />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Layout id="bailiff-screen">
      <LayoutHeader title="Kyc Request" />
      <SectionCointaner breadCrum={breadCrum}>
        <div style={{ padding: 20 }}>
          <Row justify={"center"}>
            <Col xl={16} lg={18} md={22} xs={24}>
              {renderBody()}
            </Col>
          </Row>
        </div>
      </SectionCointaner>
      <DialogKycAction />
      <TriggerInit />
    </Layout>
  );
};
export default KycApprove;
